// The window event that asks for a moment survey. survey-probe.js listens, and survey-call-trigger.js dispatches it.
export const SURVEY_MOMENT_EVENT = 'survey-moment';

// The window event that closes an open moment survey with no dismissal, as the mobile app does. calls/index.js dispatches it when a call starts.
export const SURVEY_YIELD_EVENT = 'survey-yield';

// The question types of the Question switch in public/js/react/survey/Questions.tsx. The server skips a survey with any other type.
export const SURVEY_RENDERED_TYPES = [
    'single_choice',
    'multi_choice',
    'emoji_scale',
    'nps_scale',
    'short_text',
    'long_text',
    'maxdiff',
    'price',
];

/** The GET /v1/surveys/eligible path for a surface, event and survey key. */
export function eligiblePath({ surface, event, surveyKey }) {
    const params = new URLSearchParams({ surface, types: SURVEY_RENDERED_TYPES.join(',') });
    if (event) params.set('event', event);
    if (surveyKey) params.set('survey_key', surveyKey);
    return `/surveys/eligible?${params}`;
}
